import { ArrowRightCircleIcon, PencilSquareIcon } from '@heroicons/react/24/outline'
import Notes from 'pages/Loan/Servicing/Notes/Notes'
import { useState } from 'react'
import { useSelector } from 'react-redux'

export const NotesSlide = () => {
  const loanDetail = useSelector((state: any) => state.loanDetail)
  const [isShowSlide, setShowSlide] = useState(false)

  const onShowSlide = () => {
    setShowSlide(!isShowSlide)
  }

  return (
    <>
      <div className="fixed right-0 top-[calc(25%+60px)] z-40">
        <button
          className="p-3 rounded-r-none ring-[1px] ring-shade-blue bg-shade-blue text-white border hover:bg-white border-shade-blue hover:text-shade-blue rounded flex items-center gap-2 border-r-0 w-[155px]"
          onClick={onShowSlide}
        >
          <PencilSquareIcon className="w-6 h-6" /> Notes
        </button>
      </div>
      {isShowSlide && (
        <div
          className={`shadow1 fixed bg-white border rounded-l z-50 right-0 top-[5vh] bottom-0 transition-[right] w-[96rem] h-[90vh] overflow-auto ease-in-out ${
            isShowSlide ? 'right-0' : '-right-[96rem]'
          }`}
        >
          <div className="w-[96rem] fixed z-20 rounded-t flex justify-between p-3 font-bold text-sm place-items-center items-center text-shade-blue border-b bg-white">
            <div className="flex items-center">
              <p className="text-lg text-gray-800">Notes: </p>
              <span className="text-[16px] ml-2 italic font-semibold">
                {loanDetail.byteproFileName > 0 ? loanDetail.byteproFileName : loanDetail.loanNumber}
              </span>
            </div>

            <button className="hover:underline hover-shadow1 p-1 rounded" onClick={onShowSlide}>
              <ArrowRightCircleIcon className="w-5 h-5" />
            </button>
          </div>
          <div className="pt-14 h-fit overflow-auto relative text-sm text-gray-900">
            <Notes child={true} />
          </div>
        </div>
      )}
    </>
  )
}
